import store from 'State/store';

export const getStoreState = (key) => {
  const state = store?.getState();
  return key ? state?.[key] : state;
};

export const getStoreDispatch = () => {
  return store?.dispatch;
};

export const getDefaultConfig = (key) => {
  const defaultConfig = getStoreState('appConfig')?.defaultConfig;
  return key ? defaultConfig?.[key] : defaultConfig;
};
